export function spacer(item: any, widgetName: string) {
	return null;
}